export const DRIVER_APP_URL_IOS =
  'https://apps.apple.com/us/app/bambi-nemt-driver/id1639944128';
export const DRIVER_APP_URL_ANDROID =
  'https://play.google.com/store/apps/details?id=com.hibambi.bambi';
